<template>
  <div>
    <CoreItemTwo/>
    <CoreItemOne/>
    <CoreItemThree/>
    <CoreItemFour/>
    <UdiDigitization />
    <div class="section-container">
      <div class="section-title">软件著作权登记书</div>
      <div class="certificate-carousel">
        <el-carousel :interval="4000" type="card" height="600PX">
          <el-carousel-item v-for="(item, index) in certificateList" :key="index">
            <div class="certificate-item">
              <img :src="item.src" :alt="item.name" />
              <div class="certificate-info">
                <h3>{{ item.name }}</h3>
                <p>登记号：{{ item.number }}</p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>
<script>
import CoreItemOne from './CoreItemOne.vue'
import CoreItemTwo from './CoreItemTwo.vue'
import CoreItemThree from './CoreItemThree.vue'
import CoreItemFour from './CoreItemFour.vue'
import UdiDigitization from './UdiDigitization.vue'
export default {
  components: {
    CoreItemOne,
    CoreItemTwo,
    CoreItemThree,
    CoreItemFour,
    UdiDigitization
  },
  data() {
    return {
      certificateList: [
        {
          name: '医疗器械一站式采购管理系统V1.0',
          number: '2024SR0571314',
          src: require('@/assets/img/certificates/certificate1.jpg')
        },
        {
          name: '医疗器械供应链数据分析平台V1.0',
          number: '2024SR0572050',
          src: require('@/assets/img/certificates/certificate2.jpg')
        },
        {
          name: '医疗器械供应链物流协同系统V1.0',
          number: '2024SR0572069',
          src: require('@/assets/img/certificates/certificate3.jpg')
        },
        {
          name: '医疗器械供应链SaaS管理平台V1.0',
          number: '2024SR0770717',
          src: require('@/assets/img/certificates/certificate4.jpg')
        },
        {
          name: '全链条产品交易优化系统V1.0',
          number: '2024SR808583',
          src: require('@/assets/img/certificates/certificate5.jpg')
        },
        {
          name: '一站式销售管理系统V1.0',
          number: '2024SR1821445',
          src: require('@/assets/img/certificates/certificate6.jpg')
        },
        {
          name: '生产过程优化管理平台V1.0',
          number: '2024SR1821390',
          src: require('@/assets/img/certificates/certificate7.jpg')
        },
        {
          name: '供应链仓库管理系统V1.0',
          number: '2024SR1821370',
          src: require('@/assets/img/certificates/certificate8.jpg')
        },
        {
          name: '产品追溯管理系统V1.0',
          number: '2024SR1820746',
          src: require('@/assets/img/certificates/certificate9.jpg')
        },
        {
          name: '全渠道质量维护管理系统V1.0',
          number: '2024SR1816672',
          src: require('@/assets/img/certificates/certificate10.jpg')
        },
        {
          name: '企业高值耗材数据分析平台V1.0',
          number: '2024SR1808678',
          src: require('@/assets/img/certificates/certificate11.jpg')
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.section-container {
  padding: $spacing-lg 0;
  
  .certificate-carousel {
    width: 70%;
    margin: 0 auto;
    padding: $spacing-md 0;

    @media screen and (max-width: $screen-md) {
      width: 90%;
      padding: $spacing-sm 0;
    }

    :deep(.el-carousel__container) {
      @media screen and (max-width: $screen-md) {
        height: 50vh !important;
      }
    }

    :deep(.el-carousel__item) {
      .el-carousel__mask {
        background-color: transparent;
      }
    }
  }

  .certificate-item {
    width: 96%;
    height: 100%;
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background: $white;
    border-radius: $border-radius-lg;
    box-shadow: $box-shadow-base;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    overflow: hidden;
    
    @media screen and (max-width: $screen-md) {
      width: 100%;
      padding: $spacing-md $spacing-sm;
      border-radius: $border-radius-md;
    }
    
    img {
      width: 100%;
      height: auto;
      max-height: 70%;
      object-fit: contain;
      margin: $spacing-sm 0;
      padding: $spacing-sm;
      @media screen and (max-width: $screen-md) {
        max-height: 65%;
        margin: $spacing-xs 0;
        padding: $spacing-xs;
      }
    }

    .certificate-info {
      padding: $spacing-md $spacing-sm;
      text-align: center;
      width: 100%;
      background: transparent;
      margin-top: auto;
      transition: all 0.3s ease;
      position: relative;
      
      h3 {
        font-size: $font-size-xl;
        color: $text-color-primary;
        margin-bottom: $spacing-xs;
        font-weight: $font-weight-semibold;
        transition: color 0.3s ease;
        
        @media screen and (max-width: $screen-md) {
          font-size: $font-size-lg;
          margin-bottom: $spacing-xs / 2;
        }
      }

      p {
        font-size: $font-size-base;
        color: $text-color-secondary;
        line-height: $line-height-lg;
        margin: 0;
        
        @media screen and (max-width: $screen-md) {
          font-size: $font-size-sm;
        }
      }
    }
  }
}

:deep(.el-carousel__arrow) {
  background: $primary-blue;
  border-radius: 50%;
  width: 44PX;
  height: 44PX;
  box-shadow: 0 2PX 12PX rgba($primary-blue, 0.2);
  
  &:hover {
    background: lighten($primary-blue, 10%);
  }
  
  @media screen and (max-width: $screen-md) {
    width: 36PX;
    height: 36PX;
  }
}

:deep(.el-carousel__indicators) {
  bottom: -40PX;
  
  .el-carousel__button {
    background-color: rgba($primary-blue, 0.3);
    width: 30PX;
    border-radius: 4PX;
    transition: all 0.3s ease;
  }
  
  .el-carousel__indicator.is-active .el-carousel__button {
    background: $primary-blue;
    width: 40PX;
  }
}
</style>